import ApiService from './ApiService';

class ChangePasswordService {
  async performChangePassword(payload) {
    try {
      const response = await ApiService.call('/secured/change_password', 'POST', payload);

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }
}
export default new ChangePasswordService();
